import {REPORT_QUALIFIED_FOR_INCENTIVE_TRIP} from '/enum/records.enum';

export default {
  reportName: REPORT_QUALIFIED_FOR_INCENTIVE_TRIP,
};
